const VISION_INSURANCE_TYPES = ['PatientVisionInsurance', 'PatientVisionSecondaryInsurance', 'PatientVisionTertiaryInsurance']

export const getPriorityLabel = (insuranceType) => {
  switch (insuranceType) {
    case 'PatientVisionInsurance':
    case 'PatientMedicalInsurance':
      return 'Primary'
    case 'PatientVisionSecondaryInsurance':
    case 'PatientSecondaryInsurance':
      return 'Secondary'
    case 'PatientVisionTertiaryInsurance':
    case 'PatientTertiaryInsurance':
      return 'Tertiary'
    default:
      return ''
  }
}

export const groupOrderInsurances = (ordersInsurances = []) => {
  const visionInsurances = []
  const medicalInsurances = []

  ordersInsurances.forEach((orderInsurance) => {
    const insuranceType = orderInsurance.patient_insurance_attributes?.insurance_type
    if (VISION_INSURANCE_TYPES.includes(insuranceType)) {
      visionInsurances.push(orderInsurance)
    } else {
      medicalInsurances.push(orderInsurance)
    }
  })

  return { visionInsurances, medicalInsurances }
}

export const getInsuranceLabel = (orderInsurance) => {
  const insuranceName = orderInsurance.patient_insurance_attributes?.insurance_name || 'Insurance'
  const priorityLabel = getPriorityLabel(orderInsurance.patient_insurance_attributes?.insurance_type)
  return priorityLabel ? `${insuranceName} (${priorityLabel})` : insuranceName
}

export const withOrdersInsuranceId = (filters = {}, ordersInsuranceId) => (
  ordersInsuranceId ? { ...filters, orders_insurance_id: ordersInsuranceId } : filters
)
